import type { TFunction } from "i18next"
import type { GridColDef, GridSortDirection } from "@mui/x-data-grid"

import type { DeviceGroupRef } from "types/group.types"
import type { AddDevicesToGroupTableRow, DeviceWGroups } from "types/device.types"

import GroupChips from "widgets/deviceGroups/GroupChips"
import { getGroupsString } from "./tables"

export const getAddDevicesToGroupTableColumns = (
  t: TFunction,
): GridColDef<AddDevicesToGroupTableRow>[] => {
  return [
    { field: "name", headerName: t("generic.DEVICE_NAME"), flex: 1, minWidth: 200 },
    { field: "deviceId", headerName: t("device.DEVICE_ID"), flex: 1, minWidth: 100 },
    {
      field: "groups",
      headerName: t("device_groups.DEVICE_GROUPS"),
      flex: 1,
      minWidth: 240,
      valueFormatter: (groups: DeviceGroupRef[]) => getGroupsString(groups),
      // As mui-datatables' sortCompare: it takes the direction and is used as is.
      getSortComparator: (direction: GridSortDirection) =>
        direction
          ? (a: DeviceGroupRef[], b: DeviceGroupRef[]) =>
              direction === "asc"
                ? getGroupsString(a).localeCompare(getGroupsString(b))
                : getGroupsString(b).localeCompare(getGroupsString(a))
          : undefined,
      getApplyQuickFilterFn: (search) => (groups: DeviceGroupRef[]) =>
        (groups ?? []).some((group) =>
          group.name.toLowerCase().includes(String(search).toLowerCase()),
        ),
      renderCell: ({ value }) => (value ? <GroupChips groups={value} noWrap /> : null),
    },
  ]
}

export const getAddDevicesToGroupTableRows = (
  devices: DeviceWGroups[],
): AddDevicesToGroupTableRow[] => {
  return devices?.map((deviceWExtras) => {
    const device = deviceWExtras.device
    return {
      id: device.less_id,
      name: device.name,
      deviceId: device.less_id,
      groups: deviceWExtras.groups,
    }
  })
}
